export const resolveOptionLabel = (
    options: { text: string; value: string | number }[],
    id: string | number | null | undefined,
): string | null => {
    if (id === null || id === undefined || id === '') {
        return null;
    }
    const match = options.find(option => Number(option.value) === Number(id));
    return match?.text ?? null;
};